<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="卡派发货提单" width="800">
      <el-form :inline="false"  class="" style="text-align: left">
        <el-form-item  label="RII出库单号">
          <el-input style="width:200px" disabled v-model="formInline.riiNumber" ></el-input>
        </el-form-item>
        <el-form-item  label="copilot单号">
          <el-input style="width:200px" disabled v-model="formInline.trackNumber" ></el-input>
        </el-form-item>
        <el-form-item  label="自发卡车BOL">
          <el-upload
              v-model:file-list="formInline.sendFile"
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-success="handleSendFile"
              :on-remove="handleRemove"
              :before-upload="handleBeforeUpload"
              accept="image/*"
          >
            <el-icon><Plus /></el-icon>
          </el-upload>

          <el-dialog v-model="dialogVisible">
            <img :src="dialogImageUrl" alt="Preview Image" />
          </el-dialog>
        </el-form-item>
        <div class="flex flex-row-right flex-item-center">
          <el-button style="margin-right:10px"  type="danger" @click="submit()" >上传提单</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
  ElUpload, ElMessage,ElIcon
} from "element-plus";
import {addOutFile} from "@/utils/api";
import {uploadUrl} from "@/utils/requset"
export default {
  name: "addRIIFile",
  components:{
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    ElUpload,
    ElIcon
  },
  data(){
    return{
      dialogTableVisible:false,
      uploadUrl:"",
      formInline:{"sendChannel":"","riiNumber":"",sendFile:[],trackNumber:''},
      packingLableUrl:[],
      truckBol:[],
      dialogImageUrl:'',
      dialogVisible :false,
    }
  },
  beforeMount() {
    this.uploadUrl =uploadUrl
  },
  methods:{
    open(data){
      this.dialogTableVisible=true;
      this.formInline.riiNumber = data.riiNumber
      this.formInline.trackNumber = data.trackNumber
      this.formInline.sendFile = data.sendFile
    },
    handleSendFile(response){
      console.log(response)
      //this.formInline.sendFile.push({name:response.filename,url:response.location})
    },
    handleRemove(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
    },
    handleBeforeUpload(file){
      const fileExt = file.name.split('.').pop().toLowerCase();
      // 方法2：检查MIME类型（更可靠）
      const isImage = file.type.startsWith('image/');

      if ( !['jpg', 'jpeg', 'png', 'gif'].includes(fileExt) || !isImage) {
        ElMessage.error('只能上传图片');
        return false;
      }
      return true;
    },
    submit(){
      if(!this.formInline.trackNumber){
        ElMessage.warning('请输入卡派运单号')
        return
      }
      if(this.packingLableUrl.sendFile==0){
        ElMessage.warning('请上传卡派发货提单')
        return
      }
      addOutFile({
        riiNumber:this.formInline.riiNumber,
        trackNumber:this.formInline.trackNumber,
        sendFile:this.formInline.sendFile,
      }).then(res=>{
        this.dialogTableVisible = false
        this.$emit('close',res)
      }).catch(err=>{
        console.log(err)
      })
    },
    handlePictureCardPreview(uploadFile) {
      this.dialogImageUrl = uploadFile.url
      this.dialogVisible = true
    }
  },


}
</script>
<style scoped>
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
::v-deep .el-form-item__label{
  width: 200px;
}

</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}
</style>